module.exports = __webpack_public_path__ + "img/tijiao.abcf1b33.png";